module.exports = __webpack_public_path__ + "static/media/img98.60a819f4.jpg";